/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var FolderCloseIcon = createIcon({
  name: 'FolderCloseIcon',
  height: 1024,
  width: 1097,
  svgPath: 'M1097.563 0v658.286c0 0-0.421 73.611-73.563 73.611-83.591 0-512 0-512 0l-51.826 81.083c0 0-30.043 64.734-94.043 64.734-73.143 0-243.257 0-292.571 0-83.591 0-73.143-73.143-73.143-73.143v-804.571h1097.147z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});

export default FolderCloseIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/folder-close-icon.js
// module id = 1132
// module chunks = 0